import { DatePipe, DecimalPipe } from '@angular/common';
import { ChangeDetectorRef, Inject, LOCALE_ID, Pipe } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppSettingsDto } from '../../services/api.services';
import { SettingsDrivenPipeOverride } from './settings-driven-pipe-override';

@Pipe({
  name: 'decimal',
  pure: false,
  standalone: false
})
export class SettingsDrivenDecimalPipe extends SettingsDrivenPipeOverride<DecimalPipe> {
  protected getPipe() {
    return new DecimalPipe(this.pipeLocale);
  }

  protected onTransform(pipe: DecimalPipe, settings: AppSettingsDto, value: any, digitsInfo?: string, locale?: string) {
    let locale_ = locale ?? settings.locale ?? this.pipeLocale;

    return pipe.transform(value, digitsInfo, locale_);
  }
}
